// app
export const REQUEST_FETCH_X_CSRF_TOKEN = 'REQUEST_FETCH_X_CSRF_TOKEN';
export const SUCCESS_FETCH_X_CSRF_TOKEN = 'SUCCESS_FETCH_X_CSRF_TOKEN';
export const FAILURE_FETCH_X_CSRF_TOKEN = 'FAILURE_FETCH_X_CSRF_TOKEN';
export const SET_X_CSRF_TOKEN = 'SET_X_CSRF_TOKEN';
export const SET_ROOT_PATH = 'SET_ROOT_PATH'; // Admin, Backyardの判定用
export const SET_DEVICE_VARIANT = 'SET_DEVICE_VARIANT';

// flashMessage
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE';

// survey
// 回答画面の初回表示時
export const REQUEST_FETCH_INITIAL_SURVEY_STEP = 'REQUEST_FETCH_INITIAL_SURVEY_STEP';
export const SUCCESS_FETCH_INITIAL_SURVEY_STEP = 'SUCCESS_FETCH_INITIAL_SURVEY_STEP';
export const FAILURE_FETCH_INITIAL_SURVEY_STEP = 'FAILURE_FETCH_INITIAL_SURVEY_STEP';
// 回答画面の変更時
export const REQUEST_CHANGE_CURRENT_SURVEY_STEP = 'REQUEST_CHANGE_CURRENT_SURVEY_STEP';
export const SUCCESS_CHANGE_CURRENT_SURVEY_STEP = 'SUCCESS_CHANGE_CURRENT_SURVEY_STEP';
// 回答画面の変更時に、データがなければリクエストする
export const REQUEST_FETCH_SURVEY_STEP = 'REQUEST_FETCH_SURVEY_STEP';
export const SUCCESS_FETCH_SURVEY_STEP = 'SUCCESS_FETCH_SURVEY_STEP';
export const FAILURE_FETCH_SURVEY_STEP = 'FAILURE_FETCH_SURVEY_STEP';
// ツリー項目（ex. 部署選択）の選択肢変更
export const CHANGE_TREE_SELECT_CHOICES = 'CHANGE_TREE_SELECT_CHOICES';
export const RESET_TREE_SELECT_CHOICES = 'RESET_TREE_SELECT_CHOICES';
// ツリー項目（ex. 部署選択）の選択肢リクエスト
export const REQUEST_FETCH_TREE_SELECT_CHOICES = 'REQUEST_FETCH_TREE_SELECT_CHOICES';
export const SUCCESS_FETCH_TREE_SELECT_CHOICES = 'SUCCESS_FETCH_TREE_SELECT_CHOICES';
export const FAILURE_FETCH_TREE_SELECT_CHOICES = 'FAILURE_FETCH_TREE_SELECT_CHOICES';
// ツリー項目（ex. 部署選択）のキーワード検索モーダル
export const TOGGLE_TREE_SELECT_SEARCH_MODAL = 'TOGGLE_SEARCH_MODAL';
// ツリー項目（ex. 部署選択）のツリー表示モーダル
export const TOGGLE_TREE_SELECT_DIVE_MODAL = 'TOGGLE_DIVE_MODAL';
// 回答変更
export const CHANGE_ANSWER = 'CHANGE_ANSWER';
// 回答が無効か判定（ex.選択肢を選んでいない）
export const VERIFY_ANSWER = 'VERIFY_ANSWER';
// 回答が無効な場合
export const HAS_INVALID_ANSWER = 'HAS_INVALID_ANSWER';
export const RESET_ERROR_TOAST = 'RESET_ERROR_TOAST';
// 回答をリクエスト
export const REQUEST_POST_ANSWERS = 'REQUEST_POST_ANSWERS';
export const SUCCESS_POST_ANSWERS = 'SUCCESS_POST_ANSWERS';
export const FAILURE_POST_ANSWERS = 'FAILURE_POST_ANSWERS';
// 画面のアニメーション
export const SLIDE_NEXT_STEP = 'SLIDE_NEXT_STEP';
export const SLIDE_PREV_STEP = 'SLIDE_PREV_STEP';
// PCでキーバインディング対応の説明文非表示
export const RESET_KEY_BIND_EXPLANATION = 'RESET_KEY_BIND_EXPLANATION';
// ConfirmationStepで、回答を確定するリクエスト
export const REQUEST_POST_COMPLETE_SURVEY = 'REQUEST_POST_COMPLETE_SURVEY';
export const SUCCESS_POST_COMPLETE_SURVEY = 'SUCCESS_POST_COMPLETE_SURVEY';
export const FAILURE_POST_COMPLETE_SURVEY = 'FAILURE_POST_COMPLETE_SURVEY';

// backend/ui
export const TOGGLE_SIGN_OUT_MODAL = 'TOGGLE_SIGN_OUT_MODAL';
export const TOGGLE_RESET_PASSWORD_VIEW = 'TOGGLE_RESET_PASSWORD_VIEW';
export const TOGGLE_TUTORIAL_MODAL = 'TOGGLE_TUTORIAL_MODAL';
export const CHANGE_TUTORIAL_INDEX = 'CHANGE_TUTORIAL_INDEX';
export const TOGGLE_COMPANY_LIST = 'TOGGLE_COMPANY_LIST';

// backend/user
export const REQUEST_VERIFY_SESSION = 'REQUEST_VERIFY_SESSION';
export const SUCCESS_AUTHENTICATION = 'SUCCESS_AUTHENTICATION';
export const FAILURE_AUTHENTICATION = 'FAILURE_AUTHENTICATION';
export const FAILURE_VERIFY_SESSION = 'FAILURE_VERIFY_SESSION';
export const CHANGE_SIGN_IN_EMAIL = 'CHANGE_SIGN_IN_EMAIL';
export const CHANGE_SIGN_IN_PASSWORD = 'CHANGE_SIGN_IN_PASSWORD';
export const TOGGLE_SESSION_EXTENDED = 'TOGGLE_SESSION_EXTENDED';
export const REQUEST_SIGN_IN = 'REQUEST_SIGN_IN';
export const SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
export const FAILURE_SIGN_IN = 'FAILURE_SIGN_IN';
export const REQUEST_SIGN_OUT = 'REQUEST_SIGN_OUT';
export const SUCCESS_SIGN_OUT = 'SUCCESS_SIGN_OUT';
export const FAILURE_SIGN_OUT = 'FAILURE_SIGN_OUT';
export const CHANGE_PASSWORD_RESET_EMAIL = 'CHANGE_PASSWORD_RESET_EMAIL';
export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const SUCCESS_RESET_PASSWORD = 'SUCCESS_RESET_PASSWORD';
export const FAILURE_RESET_PASSWORD = 'FAILURE_RESET_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_CONFIRMATION = 'CHANGE_PASSWORD_CONFIRMATION';
export const REQUEST_UPDATE_PASSWORD = 'REQUEST_UPDATE_PASSWORD';
export const SUCCESS_UPDATE_PASSWORD = 'SUCCESS_UPDATE_PASSWORD';
export const FAILURE_UPDATE_PASSWORD = 'FAILURE_UPDATE_PASSWORD';
export const TOGGLE_PRIVACY_POLICY = 'TOGGLE_PRIVACY_POLICY';
export const REQUEST_INITIALIZE_CONFIRMATION = 'REQUEST_INITIALIZE_CONFIRMATION';
export const SUCCESS_INITIALIZE_CONFIRMATION = 'SUCCESS_INITIALIZE_CONFIRMATION';
export const FAILURE_INITIALIZE_CONFIRMATION = 'FAILURE_INITIALIZE_CONFIRMATION';
export const REQUEST_INITIALIZE_RECONFIRMATION = 'REQUEST_INITIALIZE_RECONFIRMATION';
export const SUCCESS_INITIALIZE_RECONFIRMATION = 'SUCCESS_INITIALIZE_RECONFIRMATION';
export const FAILURE_INITIALIZE_RECONFIRMATION = 'FAILURE_INITIALIZE_RECONFIRMATION';
export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const SUCCESS_REGISTER = 'SUCCESS_REGISTER';
export const FAILURE_REGISTER = 'FAILURE_REGISTER';
export const REQUEST_FETCH_USERS = 'REQUEST_FETCH_USERS';
export const SUCCESS_FETCH_USERS = 'SUCCESS_FETCH_USERS';
export const FAILURE_FETCH_USERS = 'FAILURE_FETCH_USERS';
export const REQUEST_CREATE_USER = 'REQUEST_CREATE_USER';
export const SUCCESS_CREATE_USER = 'SUCCESS_CREATE_USER';
export const FAILURE_CREATE_USER = 'FAILURE_CREATE_USER';
export const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER';
export const SUCCESS_UPDATE_USER = 'SUCCESS_UPDATE_USER';
export const FAILURE_UPDATE_USER = 'FAILURE_UPDATE_USER';
export const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER';
export const SUCCESS_DELETE_USER = 'SUCCESS_DELETE_USER';
export const FAILURE_DELETE_USER = 'FAILURE_DELETE_USER';
export const RESET_USERS_STATE = 'RESET_USERS_STATE';

// backend/engagementSurvey/survey
export const RESET_SURVEY_STATE = 'RESET_SURVEY_STATE';
export const REQUEST_FETCH_SURVEYS = 'REQUEST_FETCH_SURVEYS';
export const SUCCESS_FETCH_SURVEYS = 'SUCCESS_FETCH_SURVEYS';
export const FAILURE_FETCH_SURVEYS = 'FAILURE_FETCH_SURVEYS';
export const REQUEST_CREATE_SURVEY = 'REQUEST_CREATE_SURVEY';
export const SUCCESS_CREATE_SURVEY = 'SUCCESS_CREATE_SURVEY';
export const FAILURE_CREATE_SURVEY = 'FAILURE_CREATE_SURVEY';
export const REQUEST_UPDATE_SURVEY = 'REQUEST_UPDATE_SURVEY';
export const SUCCESS_UPDATE_SURVEY = 'SUCCESS_UPDATE_SURVEY';
export const FAILURE_UPDATE_SURVEY = 'FAILURE_UPDATE_SURVEY';
export const REQUEST_DELETE_SURVEY = 'REQUEST_DELETE_SURVEY';
export const SUCCESS_DELETE_SURVEY = 'SUCCESS_DELETE_SURVEY';
export const FAILURE_DELETE_SURVEY = 'FAILURE_DELETE_SURVEY';

// backend/engagementSurvey/result
export const SET_SURVEY_ID = 'SET_SURVEY_ID';
export const RESET_SURVEY_ID = 'RESET_SURVEY_ID';
export const REQUEST_FETCH_SURVEY_RESULT_RATIO_SUMMARY =
  'REQUEST_FETCH_SURVEY_RESULT_RATIO_SUMMARY';
export const SUCCESS_FETCH_SURVEY_RESULT_RATIO_SUMMARY =
  'SUCCESS_FETCH_SURVEY_RESULT_RATIO_SUMMARY';
export const FAILURE_FETCH_SURVEY_RESULT_RATIO_SUMMARY =
  'FAILURE_FETCH_SURVEY_RESULT_RATIO_SUMMARY';
export const REQUEST_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION =
  'REQUEST_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION';
export const SUCCESS_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION =
  'SUCCESS_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION';
export const FAILURE_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION =
  'FAILURE_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION';
export const REQUEST_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS =
  'REQUEST_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS';
export const SUCCESS_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS =
  'SUCCESS_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS';
export const FAILURE_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS =
  'FAILURE_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS';
export const REQUEST_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES =
  'REQUEST_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES';
export const SUCCESS_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES =
  'SUCCESS_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES';
export const FAILURE_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES =
  'FAILURE_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES';
export const REQUEST_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS =
  'REQUEST_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS';
export const SUCCESS_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS =
  'SUCCESS_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS';
export const FAILURE_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS =
  'FAILURE_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS';
export const REQUEST_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY =
  'REQUEST_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY';
export const SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY =
  'SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY';
export const FAILURE_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY =
  'FAILURE_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY';
export const REQUEST_FETCH_SURVEY_RESULT_CATEGORY_DETAIL =
  'REQUEST_FETCH_SURVEY_RESULT_CATEGORY_DETAIL';
export const SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_DETAIL =
  'SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_DETAIL';
export const FAILURE_FETCH_SURVEY_RESULT_CATEGORY_DETAIL =
  'FAILURE_FETCH_SURVEY_RESULT_CATEGORY_DETAIL';

// backend/engagementSurvey/comparison
export const REQUEST_FETCH_ENGAGEMENT_SURVEY_SEGMENTS = 'REQUEST_FETCH_ENGAGEMENT_SURVEY_SEGMENTS';
export const SUCCESS_FETCH_ENGAGEMENT_SURVEY_SEGMENTS = 'SUCCESS_FETCH_ENGAGEMENT_SURVEY_SEGMENTS';
export const FAILURE_FETCH_ENGAGEMENT_SURVEY_SEGMENTS = 'FAILURE_FETCH_ENGAGEMENT_SURVEY_SEGMENTS';
export const SET_ACTIVE_ENGAGEMENT_SURVEY_SEGMENT = 'SET_ACTIVE_ENGAGEMENT_SURVEY_SEGMENT';
export const TOGGLE_ENGAGEMENT_SURVEY_SEGMENTS_GROUP_CHECK_BOX =
  'TOGGLE_ENGAGEMENT_SURVEY_SEGMENTS_GROUP_CHECK_BOX';
export const CHANGE_DEPARTMENT_SEGMENT_GROUPS_SEARCH_KEYWORD =
  'CHANGE_DEPARTMENT_SEGMENT_GROUPS_SEARCH_KEYWORD';
export const SET_FILTERED_DEPARTMENT_SEGMENT_GROUPS = 'SET_FILTERED_DEPARTMENT_SEGMENT_GROUPS';
export const REQUEST_FETCH_COMPARISON_SURVEY_DATA = 'REQUEST_FETCH_COMPARISON_SURVEY_DATA';
export const SUCCESS_FETCH_COMPARISON_SURVEY_DATA = 'SUCCESS_FETCH_COMPARISON_SURVEY_DATA';
export const FAILURE_FETCH_COMPARISON_SURVEY_DATA = 'FAILURE_FETCH_COMPARISON_SURVEY_DATA';
export const SET_COMPARISON_CURRENT_SURVEY = 'SET_COMPARISON_CURRENT_SURVEY';
export const CHANGE_BASE_COMPARISON_SURVEY = 'CHANGE_BASE_COMPARISON_SURVEY';
export const REMOVE_COMPARISON_SURVEY = 'REMOVE_COMPARISON_SURVEY';
export const CLEAR_COMPARISON_SURVEY_CONDITION = 'CLEAR_COMPARISON_SURVEY_CONDITION';
export const RESET_COMPARISON_SURVEY_DATA = 'RESET_COMPARISON_SURVEY_DATA';

// backend/segment
export const REQUEST_FETCH_SEGMENT_GROUPS = 'REQUEST_FETCH_SEGMENT_GROUPS';
export const SUCCESS_FETCH_SEGMENT_GROUPS = 'SUCCESS_FETCH_SEGMENT_GROUPS';
export const FAILURE_FETCH_SEGMENT_GROUPS = 'FAILURE_FETCH_SEGMENT_GROUPS';
export const SET_ACTIVE_SEGMENT = 'SET_ACTIVE_SEGMENT';
export const REQUEST_CREATE_SEGMENT_GROUP = 'REQUEST_CREATE_SEGMENT_GROUP';
export const SUCCESS_CREATE_SEGMENT_GROUP = 'SUCCESS_CREATE_SEGMENT_GROUP';
export const FAILURE_CREATE_SEGMENT_GROUP = 'FAILURE_CREATE_SEGMENT_GROUP';
export const REQUEST_UPDATE_SEGMENT_GROUP = 'REQUEST_UPDATE_SEGMENT_GROUP';
export const SUCCESS_UPDATE_SEGMENT_GROUP = 'SUCCESS_UPDATE_SEGMENT_GROUP';
export const FAILURE_UPDATE_SEGMENT_GROUP = 'FAILURE_UPDATE_SEGMENT_GROUP';
export const REQUEST_INACTIVATE_SEGMENT_GROUP = 'REQUEST_INACTIVATE_SEGMENT_GROUP';
export const SUCCESS_INACTIVATE_SEGMENT_GROUP = 'SUCCESS_INACTIVATE_SEGMENT_GROUP';
export const FAILURE_INACTIVATE_SEGMENT_GROUP = 'FAILURE_INACTIVATE_SEGMENT_GROUP';
export const REQUEST_SORT_SEGMENT_GROUP = 'REQUEST_SORT_SEGMENT_GROUP';
export const SUCCESS_SORT_SEGMENT_GROUP = 'SUCCESS_SORT_SEGMENT_GROUP';
export const FAILURE_SORT_SEGMENT_GROUP = 'FAILURE_SORT_SEGMENT_GROUP';
export const RESET_SEGMENT_GROUPS_STATE = 'RESET_SEGMENT_GROUPS_STATE';

// backend/company
export const REQUEST_FETCH_COMPANY = 'REQUEST_FETCH_COMPANY';
export const SUCCESS_FETCH_COMPANY = 'SUCCESS_FETCH_COMPANY';
export const FAILURE_FETCH_COMPANY = 'FAILURE_FETCH_COMPANY';
export const RESET_COMPANY = 'RESET_COMPANY';

// backyard/company
export const REQUEST_CREATE_COMPANY = 'REQUEST_CREATE_COMPANY';
export const SUCCESS_CREATE_COMPANY = 'SUCCESS_CREATE_COMPANY';
export const FAILURE_CREATE_COMPANY = 'FAILURE_CREATE_COMPANY';
export const REQUEST_UPDATE_COMPANY = 'REQUEST_UPDATE_COMPANY';
export const SUCCESS_UPDATE_COMPANY = 'SUCCESS_UPDATE_COMPANY';
export const FAILURE_UPDATE_COMPANY = 'FAILURE_UPDATE_COMPANY';
export const CHANGE_COMPANY_SEARCH_KEYWORD = 'CHANGE_COMPANY_SEARCH_KEYWORD';
export const FILTER_COMPANIES = 'FILTER_COMPANIES';
export const REQUEST_SEARCH_COMPANIES = 'companies/requestSearch';
export const SUCCESS_SEARCH_COMPANIES = 'companies/successSearch';
export const FAILURE_SEARCH_COMPANIES = 'companies/failureSearch';
export const SET_SEARCH_COMPANY_DEMO_PARAMS = 'companies/setSearchDemoParams';
export const SET_SEARCH_COMPANY_STATUS = 'companies/setSearchStatus';
